export const name = '@rails-upload';

const state = {
  uploadModel: {},
};
export function setUploadModel(uploadModel) {
  state.uploadModel = uploadModel;
}

export function getUploadModel() {
  return state.uploadModel;
}

export const UPLOADING = 'UPLOADING';
export const PROCESSING = 'PROCESSING';
export const ANALYZING = 'ANALYZING';
export const READY = 'READY';
export const FAILED = 'FAILED';
